exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.header-description {\n  border: 1px solid red;\n  padding: 15px;\n  margin-top: 20vm!important;\n  color: #d32f2f;\n}\n", ""]);

// exports
